import { AssetCollection, AssetType } from '@unistocks/proxy/axios-client';
import { Filter } from '@unistocks/types';

export interface PortfolioFilter {
  /** What type of assets to include. Default value is 'all' */
  type?: AssetCollection;
  /** Optionally include or exclude specific sections */
  sections?: Filter<string>;
  /** Optionally include or exclude specific assets */
  assets?: Filter<string>;
  /** Optionally include or exclude specific asset types */
  assetTypes?: Filter<AssetType>;
  /** Convert calculation to a selected currency */
  convertTo?: string;
}

/** Predefined filter to include all values */
export const includeAllFilter: Readonly<Filter<unknown>> = { type: 'exclude', values: [] };

/** Predefined filter to exclude all values */
export const excludeAllFilter: Readonly<Filter<unknown>> = { type: 'include', values: [] };
